import { render, staticRenderFns } from "./PermissionsHeader.vue?vue&type=template&id=3c8b1ad7&scoped=true"
import script from "./PermissionsHeader.vue?vue&type=script&lang=js"
export * from "./PermissionsHeader.vue?vue&type=script&lang=js"
import style0 from "./PermissionsHeader.vue?vue&type=style&index=0&id=3c8b1ad7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8b1ad7",
  null
  
)

export default component.exports